import { render, staticRenderFns } from "./eventForm.vue?vue&type=template&id=d50978a6&scoped=true&xmlns=true"
import script from "./eventForm.vue?vue&type=script&lang=js"
export * from "./eventForm.vue?vue&type=script&lang=js"
import style0 from "./eventForm.vue?vue&type=style&index=0&id=d50978a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50978a6",
  null
  
)

export default component.exports